import { fromJS, OrderedMap } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT, LOGIN } from '../authentication/constants'

const initialState = fromJS({
  projectFolders: {},
  projectFolderTimestamps: {},
  planFolders: {},
  planFolderTimestamps: {},
  planWithFoldersFolders: {},
  search: '',
  planSearch: '',
  planFoldersSearch: ''
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_FOLDER_SELECT_BOX: {
      let newState = state
      if (newState.get('search')) {
        newState = newState
          .set('search', '')
          .set('projectFolders', fromJS({}))
          .delete('rootProjectsObject')
      }
      return newState.delete('currentFolderId')
    }
    case actionTypes.SET_CURRENT_FOLDER_ID:
      return state.set('currentFolderId', action.currentFolderId)
    case actionTypes.CLEAR_PROJECTS:
      return state
        .delete('rootProjectsObject')
        .set('projectFolders', fromJS({}))
    case actionTypes.GET_ROOT_PROJECTS:
      return state
        .set('gettingRootProjects', true)
        .set(
          'search',
          typeof action.search === 'string'
            ? action.search
            : state.get('search')
        )
        .delete('getRootProjectsError')
    case actionTypes.GET_ROOT_PROJECTS_DONE: {
      let rootProjectsObject = state.has('rootProjectsObject')
        ? state.get('rootProjectsObject')
        : fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        })

      // set page options
      rootProjectsObject = rootProjectsObject
        .set('totalPages', action.projects.totalPages)
        .set('totalElements', action.projects.totalElements)
        .set('number', action.projects.number)
        .set('name', action.projects.name)
        .set('parentId', action.projects.parentId)

      // add content to content, id is already there -> merge it
      let content = state.has('rootProjectsObject')
        ? state.getIn(['rootProjectsObject', 'content'])
        : new OrderedMap()
      action.projects.content.forEach((element) => {
        content = content.set(element.id, fromJS(element))
      })

      return state
        .set('gettingRootProjects', action.cached)
        .set('rootProjectsObject', rootProjectsObject.set('content', content))
        .set('rootId', action.projects.rootId)
        .delete('getProjectTreeCancelToken')
        .set('rootProjectsTimestamp', action.timestamp)
    }
    case actionTypes.GET_ROOT_PROJECTS_ERROR:
      return state
        .set('gettingRootProjects', false)
        .set('getRootProjectsError', action.error)

    // is called when there is still content to load
    case actionTypes.GET_FOLDER_PROJECTS: {
      let newState = state

      if (!newState.hasIn(['projectFolders', action.folderId])) {
        const folder = fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        })

        newState = newState.setIn(
          ['projectFolders', action.folderId],
          folder.set('content', new OrderedMap())
        )
      }

      return newState
        .set('gettingFolderProjects', action.folderId)
        .delete(`getFolderProjectsError${action.folderId}`)
    }
    case actionTypes.GET_FOLDER_PROJECTS_DONE: {
      // object is already there because it's created on GET_FOLDER_PROJECTS
      let folderProjectsObject = state.getIn([
        'projectFolders',
        action.folderId
      ])

      // set page options
      folderProjectsObject = folderProjectsObject
        .set('totalPages', action.projects.totalPages)
        .set('totalElements', action.projects.totalElements)
        .set('number', action.projects.number)
        .set('name', action.projects.name)
        .set(
          'parentId',
          typeof action.parentId === 'undefined'
            ? action.projects.parentId
            : action.parentId
        )

      // add content to content, id is already there -> merge it
      let content = state.hasIn(['projectFolders', action.folderId])
        ? state.getIn(['projectFolders', action.folderId, 'content'])
        : new OrderedMap()
      action.projects.content.forEach((element) => {
        content = content.set(element.id, fromJS(element))
      })

      return state
        .set('gettingFolderProjects', action.cached)
        .setIn(
          ['projectFolders', action.folderId],
          folderProjectsObject.set('content', content)
        )
        .delete('getProjectTreeCancelToken')
        .delete(`getFolderProjectsError${action.folderId}`)
        .setIn(['projectFolderTimestamps', action.folderId], action.timestamp)
    }
    case actionTypes.GET_FOLDER_PROJECTS_ERROR:
      return state
        .set('gettingFolderProjects', false)
        .set(`getFolderProjectsError${action.folderId}`, action.error)
    case actionTypes.SET_GET_PROJECT_TREE_CANCEL_TOKEN:
      return state.set('getProjectTreeCancelToken', action.cancelToken)

    case actionTypes.CLEAR_PLAN_FOLDER_SELECT_BOX: {
      let newState = state
      if (newState.get('planSearch')) {
        newState = newState
          .set('planSearch', '')
          .set('planFolders', fromJS({}))
          .delete('rootPlansObject')
      }
      return newState.delete('currentPlanFolderId')
    }
    case actionTypes.SET_CURRENT_PLAN_FOLDER_ID:
      return state.set('currentPlanFolderId', action.currentFolderId)
    case actionTypes.CLEAR_PLANS:
      return state.delete('rootPlansObject').set('planFolders', fromJS({}))
    case actionTypes.CLEAR_FOLDER_PLANS:
      return state.setIn(
        ['planFolders', action.folderId],
        fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        }).set('content', new OrderedMap())
      )
    case actionTypes.CLEAR_FOLDER_PROJECTS:
      return state.setIn(
        ['projectFolders', action.folderId],
        fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        }).set('content', new OrderedMap())
      )
    case actionTypes.GET_ROOT_PLANS:
      return state
        .set('gettingRootPlans', true)
        .set(
          'planSearch',
          typeof action.search === 'string'
            ? action.search
            : state.get('planSearch')
        )
        .delete('getRootPlansError')
        .set('savedProjectId', action.projectId)
    case actionTypes.GET_ROOT_PLANS_DONE: {
      let rootPlansObject = state.has('rootPlansObject')
        ? state.get('rootPlansObject')
        : fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        })

      // set page options
      rootPlansObject = rootPlansObject.merge(fromJS(action.plans))

      // add content to content, id is already there -> merge it
      let content = state.has('rootPlansObject')
        ? state.getIn(['rootPlansObject', 'content'])
        : new OrderedMap()
      action.plans.content.forEach((element) => {
        content = content.set(element.id, fromJS(element))
      })

      return state
        .set('gettingRootPlans', action.cached)
        .set('rootPlansObject', rootPlansObject.set('content', content))
        .delete('getPlanTreeCancelToken')
        .set('rootPlansTimestamp', action.timestamp)
    }
    case actionTypes.GET_ROOT_PLANS_ERROR:
      return state
        .set('gettingRootPlans', false)
        .set('getRootPlansError', action.error)

    // is called when there is still content to load
    case actionTypes.GET_FOLDER_PLANS: {
      let newState = state

      if (!newState.hasIn(['planFolders', action.folderId])) {
        const folder = fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        })

        newState = newState.setIn(
          ['planFolders', action.folderId],
          folder.set('content', new OrderedMap())
        )
      }

      return newState
        .set('gettingFolderPlans', action.folderId)
        .delete(`getFolderPlansError${action.folderId}`)
    }
    case actionTypes.GET_FOLDER_PLANS_DONE: {
      // object is already there because it's created on GET_FOLDER_PLANS
      let folderPlansObject = state.getIn(['planFolders', action.folderId])

      // set page options
      folderPlansObject = folderPlansObject.merge({
        ...action.plans,
        parentId:
          typeof action.parentId === 'undefined'
            ? action.plans.parentId
            : action.parentId
      })

      // add content to content, id is already there -> merge it
      let content = state.hasIn(['planFolders', action.folderId])
        ? state.getIn(['planFolders', action.folderId, 'content'])
        : new OrderedMap()
      action.plans.content.forEach((element) => {
        content = content.set(element.id, fromJS(element))
      })

      return state
        .set('gettingFolderPlans', action.cached)
        .setIn(
          ['planFolders', action.folderId],
          folderPlansObject.set('content', content)
        )
        .delete('getPlanTreeCancelToken')
        .delete(`getFolderPlansError${action.folderId}`)
        .setIn(['planFolderTimestamps', action.folderId], action.timestamp)
    }
    case actionTypes.GET_FOLDER_PLANS_ERROR:
      return state
        .set('gettingFolderPlans', false)
        .set(`getFolderPlansError${action.folderId}`, action.error)
    case actionTypes.SET_GET_PLAN_TREE_CANCEL_TOKEN:
      return state.set('getPlanTreeCancelToken', action.cancelToken)

      // -------------

    case actionTypes.CLEAR_PLAN_SELECT_BOX: {
      let newState = state
      if (newState.get('planFoldersSearch')) {
        newState = newState
          .set('planFoldersSearch', '')
          .set('planWithFoldersFolders', fromJS({}))
          .delete('rootPlansWithFoldersObject')
      }
      return newState.delete('currentPlanWithFoldersFolderId')
    }
    case actionTypes.SET_CURRENT_PLAN_WITH_FOLDERS_FOLDER_ID:
      return state.set('currentPlanWithFoldersFolderId', action.currentFolderId)
    case actionTypes.CLEAR_PLANS_WITH_FOLDERS:
      return state
        .delete('rootPlansWithFoldersObject')
        .set('planWithFoldersFolders', fromJS({}))
    case actionTypes.GET_ROOT_PLANS_WITH_FOLDERS:
      return state
        .set('gettingRootPlansWithFolders', true)
        .set(
          'planFoldersSearch',
          typeof action.search === 'string'
            ? action.search
            : state.get('planFoldersSearch')
        )
        .delete('getRootPlansWithFoldersError')
        .set('savedProjectIdPlansWithFolders', action.projectId)
    case actionTypes.GET_ROOT_PLANS_WITH_FOLDERS_DONE: {
      let rootPlansWithFoldersObject = state.has('rootPlansWithFoldersObject')
        ? state.get('rootPlansWithFoldersObject')
        : fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        })

      // set page options
      rootPlansWithFoldersObject = rootPlansWithFoldersObject.merge(
        fromJS(action.plans)
      )

      // add content to content, id is already there -> merge it
      let content = state.has('rootPlansWithFoldersObject')
        ? state.getIn(['rootPlansWithFoldersObject', 'content'])
        : new OrderedMap()
      action.plans.content.forEach((element) => {
        content = content.set(element.id, fromJS(element))
      })

      return state
        .set('gettingRootPlansWithFolders', false)
        .set(
          'rootPlansWithFoldersObject',
          rootPlansWithFoldersObject.set('content', content)
        )
        .delete('getPlanWithFoldersTreeCancelToken')
    }
    case actionTypes.GET_ROOT_PLANS_WITH_FOLDERS_ERROR:
      return state
        .set('gettingRootPlansWithFolders', false)
        .set('getRootPlansWithFoldersError', action.error)

    // is called when there is still content to load
    case actionTypes.GET_FOLDER_PLANS_WITH_FOLDERS: {
      let newState = state

      if (!newState.hasIn(['planWithFoldersFolders', action.folderId])) {
        const folder = fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        })

        newState = newState.setIn(
          ['planWithFoldersFolders', action.folderId],
          folder.set('content', new OrderedMap())
        )
      }

      return newState
        .set('gettingFolderPlansWithFolders', action.folderId)
        .delete(`getFolderPlansWithFoldersError${action.folderId}`)
    }
    case actionTypes.GET_FOLDER_PLANS_WITH_FOLDERS_DONE: {
      // object is already there because it's created on GET_FOLDER_PLANS
      let folderPlansObject = state.getIn([
        'planWithFoldersFolders',
        action.folderId
      ])

      // set page options
      if (folderPlansObject) {
        folderPlansObject = folderPlansObject.merge({
          ...action.plans,
          parentId:
            typeof action.parentId === 'undefined'
              ? action.plans.parentId
              : action.parentId
        })
      } else {
        folderPlansObject = state.setIn(
          ['planWithFoldersFolders', action.folderId],
          {
            ...action.plans,
            parentId:
              typeof action.parentId === 'undefined'
                ? action.plans.parentId
                : action.parentId
          }
        )
      }

      // add content to content, id is already there -> merge it
      let content = state.hasIn(['planWithFoldersFolders', action.folderId])
        ? state.getIn(['planWithFoldersFolders', action.folderId, 'content'])
        : new OrderedMap()
      action.plans.content.forEach((element) => {
        content = content.set(element.id, fromJS(element))
      })

      return state
        .set('gettingFolderPlansWithFolders', false)
        .setIn(
          ['planWithFoldersFolders', action.folderId],
          folderPlansObject.set('content', content)
        )
        .delete('getPlanWithFoldersTreeCancelToken')
    }
    case actionTypes.GET_FOLDER_PLANS_WITH_FOLDERS_ERROR:
      return state
        .set('gettingFolderPlansWithFolders', false)
        .set(`getFolderPlansWithFoldersError${action.folderId}`, action.error)
    case actionTypes.SET_GET_PLAN_WITH_FOLDERS_TREE_CANCEL_TOKEN:
      return state.set('getPlanWithFoldersTreeCancelToken', action.cancelToken)

    case LOGIN:
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
